import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionKeys } from './SessionKeys';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { EncryptDecryptResponse } from '../models/response/EncryAndDecryResponse';
import { EncryptdecryptService } from '../auth/encryptdecrpt.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class PostmethodService {
  public generateToken :any
  isLoading = new Subject<boolean>();
  encrydecryresponse: EncryptDecryptResponse = new EncryptDecryptResponse();
  htheadeer: HttpHeaders = new HttpHeaders()

  constructor(private http: HttpClient,private encryptDecrypt: EncryptdecryptService,private _router: Router,private toastr: ToastrService,) { }

  public wsPost(RequestModel: any, url: string, iv: string): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': "Bearer " + JSON.parse(sessionStorage.getItem(SessionKeys.autho_token) || '{}'),
      'ClientSecret': iv
    });
    return this.http.post(url, RequestModel, { headers: headers, observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }

  public wsPostNoToken(RequestModel: any, url: string, iv: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'ClientSecret': iv
    });
    return this.http.post(url, RequestModel, { headers: headers, observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }

  public wsGet(url: string): Observable<any> {
    let headerss = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': "Bearer " + JSON.parse(sessionStorage.getItem(SessionKeys.autho_token) || '{}'),
    });
    return this.http.get(url, { headers: headerss,observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }


  handleError(Error :any) {
    let errorMessage = '';
    if(Error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = Error.error.message;

    } else {
      // Get server-side error
      errorMessage = `Error Code: ${Error.status}\nMessage: ${Error.message}`;

      if(Error.error === 'Token Expired' || Error.error === 'Invalid Token'){
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
      }
    }
    return throwError(errorMessage);
 }


 show() {
     this.isLoading.next(true);
 }

 hide() {
     this.isLoading.next(false);
 }


}
